import { defineStore } from 'pinia'

export const usePageStore = defineStore('pageStore', {
  state: () => ({
    ProductreturnsHtml: '',
    PrivacypolicyHtml: '',
    TermsOfServiceHtml: '',
    PartnerInquiryHtml: '',
    contactImg: '',
    loginImg: '',
  }),
  actions: {
    /**
     * 通用的抓取 Page 資料函式
     * @param {string} page_type - 例如 'productreturns'
     * @param {string} versionStr - 例如 'productreturnsVersion'
     * @param {string} stateKey - 要存在哪個 state (ex: 'ProductreturnsHtml')
     */
    async fetchPageData(page_type, versionStr, stateKey) {
      // 若 stateKey 對應的欄位已經有資料 → 直接 return
      if (this[stateKey]) return

      const pageVersion = localStorage.getItem(versionStr) || null

      try {
        const res = await fetch('/api/load/loadhtmlpage', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ page_type, versionStr, pageVersion }),
        })
        const json = await res.json()

        if (!json.success) {
          console.warn('取得fetchPageData失敗', json.message)
          return
        }

        if (json.isUpdated) {
          // 後端回傳新的 detail_html
          this[stateKey] = json.detail_html
          localStorage.setItem(page_type, json.detail_html)
          localStorage.setItem(versionStr, json.serverVersion)
        } else {
          // 版本無更新，從 localStorage 取
          const saveHtmlPage = localStorage.getItem(page_type)
          this[stateKey] = saveHtmlPage || ''
        }
      } catch (err) {
        console.error('fetch error:', err)
      }
    },

    async fetchImagesData(image_type, versionStr, stateKey) {
      // 若 stateKey 對應的欄位已經有資料 → 直接 return
      if (this[stateKey]) return
      const pageVersion = localStorage.getItem(versionStr) || null
      try {
        const res = await fetch('/api/load/loadpageimage', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ image_type, versionStr, pageVersion }),
        })
        const json = await res.json()

        if (!json.success) {
          console.warn('取得fetchPageData失敗', json.message)
          return
        }
        if (json.isUpdated) {
          this[stateKey] = json.image_url
          localStorage.setItem(image_type, json.image_url)
          localStorage.setItem(versionStr, json.serverVersion)
        } else {
          // 版本無更新，從 localStorage 取
          const saveHtmlPage = localStorage.getItem(image_type)
          this[stateKey] = saveHtmlPage || ''
        }
      } catch (err) {
        console.error('fetch error:', err)
      }
    },

    // 取得產品退換貨資料
    async fetchProductreturnsData() {
      await this.fetchPageData(
        'productreturns',        // page_type
        'productreturnsVersion', // versionStr
        'ProductreturnsHtml'     // stateKey
      )
    },

    // 取得隱私權政策資料
    async fetchPrivacypolicyData() {
      await this.fetchPageData(
        'privacypolicy',         // page_type
        'privacypolicyVersion',  // versionStr
        'PrivacypolicyHtml'      // stateKey
      )
    },

    // 取得服務條款資料
    async fetchTermsOfServiceData() {
      await this.fetchPageData(
        'termsofservice',        // page_type
        'termsofserviceVersion', // versionStr
        'TermsOfServiceHtml'     // stateKey
      )
    },

    // 合作夥伴接洽
    async fetchPartnerInquiryData() {
      await this.fetchPageData(
        'partnerinquiry',        // page_type
        'partnerinquiryVersion', // versionStr
        'PartnerInquiryHtml'     // stateKey
      )
    },
    // 取得聯絡我們圖片
    async fetchContactImg() {
      await this.fetchImagesData(
        'contactImg000',
        'contactVersion',
        'contactImg'
      )
    },

    // 取得登入圖片
    async fetchCheckLoginImg() {
      await this.fetchImagesData(
        'loginImg000',
        'loginVersion',
        'loginImg'
      )
    }
  },
})
